module.exports = __webpack_public_path__ + "static/img/meiti33.1fb1224a.png";